<template>
  <section class="mx-auto container text-gray-800">
    <header class="mt-8">
      <h1 class="font-bold text-lg">Form Testing</h1>
    </header>
    <section class="mt-4">
      <div class="flex">
        <div class="w-1/3">
          <h2>Basic Inputs</h2>
        </div>
        <div class="w-2/3">
          <m-form>
            <m-input id="basic-input" placeholder="Enter some text" v-model="form.input" />
            <m-textarea v-model="form.textarea"></m-textarea>
          </m-form>
          <pre>{{ form }}</pre>
        </div>
      </div>
      <format />
      <date-picker  />
      <div class="mt-8 flex">
        <div class="w-1/3">
          <h2>Advanced Inputs</h2>
        </div>
        <div class="w-2/3">
          <m-form>
            <h3>Single Checkbox</h3>
            <m-checkbox
              align="right"
              v-model="form.singleCheckbox"
              :options="['Single Check Box']"
            />
            <div class="mt-2">
              <h3>Mulitple Checkbox with Extras</h3>
              <m-checkbox class="mt-2" v-model="form.mulitpleCheckbox" :options="options" />
            </div>
            <div class="mt-2">
              <h3>Mulitple Checkbox with Extras</h3>
              <m-checkbox class="mt-2" v-model="form.mulitpleCheckbox" :options="options">
                <m-checkbox-item class="mt-2" value="Test Extra" v-model="form.mulitpleCheckbox" />
                <m-checkbox-item
                  :value="extraOption.value"
                  :label="extraOption.label"
                  class="mt-2"
                  v-model="form.mulitpleCheckbox"
                  :checked="form.mulitpleCheckbox.includes(extraOption.value)"
                  v-slot="checked"
                >
                  <m-textarea
                    v-if="checked.checked"
                    class="ml-12"
                    v-model="form.extraText"
                    heading="Please complete"
                  />
                </m-checkbox-item>
              </m-checkbox>
            </div>
            <div class="mt-2">
              <h3>Mulitple Checkbox with Children</h3>
              <div class="mt-2">
                <m-checkbox-item
                  :modelValue="form.child"
                  @change="handleChild"
                  :checked="form.child"
                  :disabled="!form.child"
                  label="Does this have children?"
                >
                  <m-checkbox
                    class="mt-2 ml-8"
                    v-model="form.childSelections"
                    :options="['Child 1', 'Child 2']"
                  />
                </m-checkbox-item>
              </div>
            </div>
            <div class="mt-2">
              <h3>Single Checkbox with Input</h3>
              <div class="mt-2">
                <m-checkbox-item
                  :value="singleOptionWithInput.value"
                  v-model="form.singleOptionWithInput"
                >
                  <template #input>
                    {{ singleOptionWithInput.value[0].value }}
                    <m-input
                      id="single-input"
                      :value="form.singleOptionInput"
                      @input="handleInput"
                      class="w-12 inline-block"
                    />
                    {{ singleOptionWithInput.value[1].value }}
                  </template>
                </m-checkbox-item>
              </div>
            </div>
          </m-form>
        </div>
      </div>
      <div class="mt-8 flex">
        <div class="w-1/3">
          <h2>Options</h2>
        </div>
        <div class="w-2/3">
          <m-form>
            <options></options>
          </m-form>
        </div>
      </div>
    </section>
    <footer class="mt-8 p-4 rounded bg-gray-200">
      <pre>{{ form }}</pre>
    </footer>
  </section>
</template>

<script>
import Format from './Format.vue';
import DatePicker from './Datepicker.vue';
import Options from './Options.vue';

const options = [
  {
    value: 'Test 1',
    label: 'Customised label',
  },
  {
    value: 'Test 2',
  },
];

const extraOption = {
  value: 'other',
  label: 'The fund currently...',
};

const singleOptionWithInput = {
  // label: 'test single option with input - label',
  value: [
    {
      value: 'test single option with input',
      input: 0,
    },
    {
      value: 'test',
    },
  ],
  displayValue() {
    if (Array.isArray(this.value)) {
      return this.value
        .map((input) => {
          if (Object.prototype.hasOwnProperty.call(input, 'input')) {
            return `${input.value} ${input.input} `;
          }
          return `${input.value}`;
        })
        .join('');
    }
    return this.value;
  },
};

export default {
  name: 'form-testing',
  components: {
    Format,
    Options,
    DatePicker,
  },
  data: () => ({
    options,
    extraOption,
    singleOptionWithInput,
    form: {
      input: '',
      textarea: '',
      singleCheckbox: true,
      mulitpleCheckbox: ['Test 2', 'other'],
      extraText: 'Test',
      child: false,
      childSelections: [],
      singleOptionWithInput: [],
      singleOptionInput: 0,
    },
  }),
  watch: {
    form: {
      handler(value) {
        if (!value.mulitpleCheckbox.includes('other')) {
          this.form.extraText = '';
        }
        if (value.childSelections.length > 0) {
          this.form.child = true;
        } else if (value.childSelections.length === 0) {
          this.form.child = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    handleChild(event) {
      if (!event) {
        this.form.childSelections = [];
      }
    },
    handleInput(event) {
      if (event === '') {
        this.form.singleOptionInput = 0;
        return;
      }
      const input = parseInt(event, 10);
      this.form.singleOptionInput = input;
      this.singleOptionWithInput.value[0].input = input;
      if (this.form.singleOptionWithInput.length > 0) {
        this.form.singleOptionWithInput = [this.singleOptionWithInput.displayValue()];
      }
    },
  },
};
</script>
